import Api from './Api';

const TOKENS_URL = `${process.env.REACT_APP_BASE_URL}/v2/tokens`;

export const getTokens = () => Api.get(TOKENS_URL);

export const addTokens = (tokens) => Api.post(TOKENS_URL, tokens);

export const addToken = (token) => Api.post(TOKENS_URL, [token]);

export const deleteToken = (tokenId) => Api.delete(`${TOKENS_URL}/${tokenId}`);
